import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  Underline,
  BoxTitle,
  BoxHead,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SearchFilterBox from "../../Components/SearchFilterBox";
import TransactionTable from "../../Components/Landlords/TransactionTable";
import ViewDetails from "../../Components/Landlords/ViewTransDetails";
import SideModal from "../../Components/SideModal";
import { IoChevronBackOutline } from "react-icons/io5";
import NotFoundModel from "../../Components/NotFoundModel";

const Transactions = ({ }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const leaseDetails = location.state?.leaseDetails;
  const searchOptions = [
    { label: "Amount", value: 2 },
    { label: "Bank Reference", value: 1 },
  ];
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [apiData, setApiData] = useState();
  const [viewDetail, setViewDetail] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const fetchFunction = async (variables = {}) => {
    const currentSearchQuery =
      variables.searchQuery !== undefined ? variables.searchQuery : searchQuery;
    const currentFilterType =
      variables.filterType !== undefined ? variables.filterType : filterType;

    const query = `&pageNum=1&s=${currentSearchQuery}&t=${currentFilterType}&landlordId=${leaseDetails?.id}`;
    const response = await axios.get(
      `${Config.apiUrl}/landlord/transaction/list?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) error = true;
    else {
      setApiData(res?.data);
      setIsFocused(true);
    }
  };

  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  // useEffect(() => {
  //   getListMutate({ searchQuery, searchQuery });
  // }, [searchQuery, searchQuery]);

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    getListMutate({
      searchQuery: values.searchQuery,
      filterType: values.filterType,
    });
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    getListMutate({ searchQuery: "", filterType: "" });
  };

  useEffect(() => {
    getListMutate({ searchQuery: "", filterType: "" });
  }, []);

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <div className="flex cursor-pointer" onClick={() => navigate(-1)}>
            <span className="hover:bg-gray-200 items-center pt-[5px]">
              <IoChevronBackOutline size={20} />
            </span>
            <BoxTitle className="!mb-0 whitespace-nowrap">
              Landlord Transactions
              <Underline />
            </BoxTitle>
          </div>
        </BoxHead>
        <SideModal isOpen={viewDetail} onClose={() => setViewDetail(false)}>
          <ViewDetails
            setViewDetail={setViewDetail}
            selectedData={selectedData}
            landlordName={leaseDetails?.name || ""}
            landlordMobile={leaseDetails?.mobile || ""}
          />
        </SideModal>

        <FilterTableWrapper>
          <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {/* Left: Total Amount */}
            <div className="flex items-center">
              <Text>
                Total amount paid to landlord:{" "}
                <span className="font-semibold">
                  ₹{data?.totalAmount || 0}
                </span>
              </Text>
            </div>

            {/* Right: Search / Filters */}
            <div className="flex flex-col gap-3 md:flex-row md:justify-end md:items-center">
              <SearchFilterBox
                options={searchOptions}
                handleFilterChange={handleFilterChange}
                handleClearFilters={handleClearFilters}
              />
            </div>

          </FilterWrapper>


          {!error && !isLoading && data && (
            <TableWrapper>
              <TransactionTable
                leaseDetails={leaseDetails}
                apiData={apiData || []}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setViewDetail={setViewDetail}
              />
              {(!apiData || apiData.length === 0) && <NotFoundModel />}
            </TableWrapper>
          )}
        </FilterTableWrapper>

        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;
const Text = tw.p`text-gray-500 text-sm font-normal`;
// const FilterTableWrapper = tw.div`rounded-lg pb-4 border mt-8 bg-white`;
// const FilterWrapper = tw.div`flex w-full flex-col md:flex-row justify-between items-stretch md:items-center pr-4 gap-4 md:gap-0`;
const SummaryBar = tw.div`bg-green-100 px-4 py-2 items-center rounded-br-lg flex justify-center md:justify-start md:-mt-6`;
export default Transactions;
